import React from 'react'
import styled from 'styled-components';
import i18n from '../i18n';
import { CardTitle } from '../styled/Card';

const GeneralInfo = (props) => {
  const general_info = props.data.general_info || {};
  const {
    best_month: bestMonth,
    laziest_month: laziestMonth,
    longest_client_in_therapy: longestClient,
    most_popular_working_day: popularDay,
    most_popular_working_hours: popularHours,
    oldest_client_in_therapy: oldestClient,
    youngest_client_in_therapy: youngestClient,
    overall_appointments_count: apptCount,
  } = general_info;

  return (
    <Grid>
      <GridCol $columns={6}>
        <Container>
          <CardTitle>
            {i18n.t('generalInfo.longestClient', { ...longestClient })}
          </CardTitle>
          <CardTitle>
            {i18n.t('generalInfo.oldestClient', { ...oldestClient })}
          </CardTitle>
          <CardTitle>
            {i18n.t('generalInfo.youngestClient', { ...youngestClient })}
          </CardTitle>
          <CardTitle>
            {i18n.t('generalInfo.workingHours', { first: popularHours?.[0], second: popularHours?.[1], third: popularHours?.[2] })}
          </CardTitle>
        </Container>
      </GridCol>
      <GridCol $columns={6}>
        <Container>
          <CardTitle>
            {i18n.t('generalInfo.workingDay', { day: popularDay })}
          </CardTitle>
          <CardTitle>
            {i18n.t('generalInfo.apptsCount', { count: apptCount })}
          </CardTitle>
          <CardTitle>
            {i18n.t('generalInfo.bestMonth', { ...bestMonth })}
          </CardTitle>
          <CardTitle>
            {i18n.t('generalInfo.laziestMonth', { ...laziestMonth })}
          </CardTitle>
        </Container>
      </GridCol>
    </Grid>
  )
};

export default GeneralInfo;

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-gap: 30px;
`;

const GridCol = styled.div`
  grid-column-start: span ${(p) => p.$columns};
`;
